import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './AccountSegmentCard.module.scss'

const AccountSegmentCard = ({ icon: Icon, title, description, onClick, showHeader, headerText, className }) => (
  <>
    {showHeader && <h5 className={classNames(classes.sectionHeader, 'mb-3')}>{headerText}</h5>}

    <div
      className={classNames(classes.categoryCard, 'd-flex align-items-start mb-0', className)}
      role='button'
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { onClick(e) } }}
    >
      <Icon className={classes.categoryIcon} />

      <div>
        <h6 className={classNames(classes.categoryTitle, 'mb-2')}>{title}</h6>
        <p className={classNames(classes.categoryDetails, 'mb-0')}>{description}</p>
      </div>
    </div>
  </>
)

AccountSegmentCard.propTypes = {
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  showHeader: PropTypes.bool,
  headerText: PropTypes.string,
  className: PropTypes.string,
}

export default AccountSegmentCard
